var _require = require('../overlay.shell'),
  buildRustscriptOverlay = _require.buildRustscriptOverlay;
module.exports = function (currentOp, optionsHtml, explain) {
  return buildRustscriptOverlay({
    className: 'rs-overlay-prompt rs-prompt-logical',
    title: currentOp,
    bodyHtml: "\n      <label class=\"rs-overlay-label\" for=\"rs-prompt-logical-select\">Operator</label>\n      <select id=\"rs-prompt-logical-select\" class=\"saito-form-select rs-prompt-logical-select\">".concat(optionsHtml, "</select>\n      <p class=\"rs-overlay-lead rs-prompt-logical-explain\">").concat(explain, "</p>\n      <p class=\"rs-prompt-validation\" hidden></p>\n    "),
    actionsHtml: "<button type=\"button\" class=\"rs-btn rs-btn-primary rs-prompt-apply\">Apply</button>"
  });
};